import { createContext } from 'react';

const LocalizationContext = createContext(null);

export { LocalizationContext };
